import classnames from 'classnames';
import React from 'react';
import styles from './tabs.css';
import { Props as TabProps } from './tab';

interface TabsProps {
  /** A single Tab component, or an array whose members are Tabs or falsy values */
  children?: React.ReactNode;
  /** The key of the currently active tab */
  activeKey: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Tabs wrapper component, that wraps child Tab/TabAnchor components
 *
 * @param {TabsProps} param
 *
 * @returns JSX.ELEMENT
 */
export const Tabs = ({ activeKey, children, className, 'data-testid': dataTestId }: TabsProps) => (
  <div className={classnames(styles.wrapper, className)} data-testid={dataTestId}>
    <div className={styles.tabs}>
      {React.Children.map(children, tab => {
        if (!React.isValidElement<TabProps>(tab) || !tab.props.tabKey) {
          return null;
        }

        const { tabKey, children: tabChildren } = tab.props;
        // covers both cases if the active key is '/pages/23887937-114a-4bf8-8b00-a4e39c30c765/overview' or '/overview'
        const isActive = activeKey.endsWith(tabKey);

        return React.isValidElement<TabProps>(tab)
          ? React.cloneElement<TabProps>(tab, { isActive }, tabChildren)
          : null;
      })}
    </div>
  </div>
);

export default Tabs;
